import { createJsonbTableEditor } from "../_resources/jsonbTableEditor.js";

export default function ({ dom, message, filePicker }) {
  let editor = null;

  const render = (pageId, base_url, hasPageEditAccess) => {
    editor = createJsonbTableEditor({
      dom,
      message,
      heading: "Related Items",
      table: 'pages',
      recordId: pageId,
      fieldName: 'related',
      base_url,
      headers: ['Image', 'Content'],
      columns: [
        { field: 'image', type: 'image', label: 'Image', columnIndex: 0, comment: `uploaded file, global https url or asset/path`  },
        { field: 'title', type: 'text', label: '文 Title', comment: "set directly here or use a translated 文 Text", required: true, columnIndex: 1 },
        { field: 'subtitle', type: 'text', label: '文 Subtitle', comment: "set directly here or use a translated 文 Text", columnIndex: 1 },
        { field: 'link', type: 'url', label: 'Link', columnIndex: 1 }
      ],
      allowReorder: hasPageEditAccess,
      allowAdd: hasPageEditAccess,
      allowEdit: hasPageEditAccess,
      allowDelete: hasPageEditAccess,
      filePicker: filePicker
    });

    editor.load();
  };

  return { render };
}